(function (jedeye) {
    "use strict";
    jedeye(window.jQuery, window, document);

}(function ($, window, document) {

        var equalheight = function (container) {

            var currentTallest = 0,
                currentRowStart = 0,
                rowDivs = new Array(),
                $el,
                topPosition = 0;

            $(container).each(function () {

                $el = $(this);
                $($el).height('auto')
                topPostion = $el.position().top;

                if (currentRowStart != topPostion) {
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }
                    rowDivs.length = 0; // empty the array
                    currentRowStart = topPostion;
                    currentTallest = $el.height();
                    rowDivs.push($el);
                } else {
                    rowDivs.push($el);
                    currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
                }
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
            });
        }

    $(window).on('ajaxUpdateComplete', function (event, context, data) {

        /**
         * Trigger custom alerts.
         */
        if (data.hasOwnProperty('alert')) {
            $(document).trigger("jedeye.showModalPopup", [data.alert.message, data.alert.title, data.alert.subtitle, data.alert.iconClass]);
        }

        /**
         * Handle specific AJAX responses.
         */
        if (context.hasOwnProperty('handler')) {
            if (context.handler == 'reservation::onExtraItemUpdate') {

                $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                    $(this).popover({
                        placement: 'auto'
                    });
                    $(this).attr('data-event-attached', '');
                });
            }

            if (context.handler == 'reservation::onPackItemToggle') {

                $('.extras-table').each(function () {
                    var $table = $(this);
                    var $buttonContainers = $('tfoot .btn-container', $table);
                    $buttonContainers.eq(data._index).each(function () {
                        var index = $(this).index();
                        $('td, th', $table).removeClass('active');
                        if (data._action == 'add') {
                            $('tr', $table).each(function () {
                                $(this).children().eq(index).addClass('active');
                            });
                            $buttonContainers.not(':eq(' + data._index + ')').find('button').prop('disabled', false);
                            if ($buttonContainers.eq(data._index).hasClass('free-item')) {
                                $('button', $(this)).prop('disabled', true);
                            }
                        } else if (data._action == 'remove') {
                            $buttonContainers.find('button').prop('disabled', false);
                            // Activate a free item if available
                            var $freeItem = $table.find('td.free-item:first');
                            if ($freeItem.length) {
                                $('tr', $table).each(function () {
                                    $(this).children().eq($freeItem.index()).addClass('active');
                                });
                                $freeItem.find('button').prop('disabled', true);
                            }

                        }
                    });
                });

            }
        }
    });

        // Scrolls up on form validation error
        $('form[data-request]').on('ajaxError', function(event, obj, context, status){
            var $el = $(this);
            setTimeout(function() {
                var $errorElems = $el.find('.has-error:first');
                if($errorElems.length > 0) {
                    $('html, body').animate({scrollTop: $errorElems.offset().top - 100}, 800);
                }
            }, 500);
        });

        // Enables form requests to be triggered by elements placed outside of it
        $('[data-request-target-elem]').on('click', function () {
            $($(this).data('request-target-elem')).submit();
        });

        $(document).router({
            // Homepage
            dom_home: function () {
                "use strict";

                var refreshShowcaseProperties = function () {
                    if ($(window).width() < 2000) {
                        if ($(window).width() > 996) {
                            $('header.showcase').addClass('full-height')
                            $('header.showcase').height($(window).height())
                        } else {
                            $('header.showcase').height('auto')
                        }
                    } else {
                        $('header.showcase').removeClass('full-height')

                    }
                }

                $(window).on("resize", function () {
                    refreshShowcaseProperties();
                });

                refreshShowcaseProperties();

                var homeSlideshowSwiper = new Swiper('#homeBannersSwiper', {
                    loop: true,
                    autoplay: 5000,
                    parallax: true,
                    effect: 'fade',
                    fade: {
                        crossFade: true
                    },
                    onTransitionEnd: function (swiper) {
                        // Sets menu color style accordingly to the active slide
                        var $activeSlide = $(swiper.wrapper).find(".swiper-slide:eq(" + swiper.activeIndex + ")")
                        if ($activeSlide.data('menu-color') != null) {
                            $('a', '.top-section nav.main-menu, .top-section .lang-selector').each(function() {
                                if($(this).hasClass('active') && $activeSlide.data('menu-hvcolor') != null) {
                                    $(this).css('color', $activeSlide.data('menu-hvcolor'));
                                }else{
                                    $(this).css('color', $activeSlide.data('menu-color'));
                                }
                            });
                        } else {
                            $('a', '.top-section nav.main-menu, .top-section .lang-selector').css('color', '')
                        }
                        if ($activeSlide.data('menu-hvcolor') != null) {
                            $('a', '.top-section nav.main-menu, .top-section .lang-selector').hover(function () {
                                $(this).css('color', $activeSlide.data('menu-hvcolor'))
                            }, function () {
                                if(!$(this).hasClass('active'))
                                    $(this).css('color', $activeSlide.data('menu-color'))
                            })
                        } else {
                            $('a', '.top-section nav.main-menu, .top-section .lang-selector').unbind('mouseenter mouseleave')
                        }
                    }
                });
            },

            // Fleet pages
            dom_fleet: function () {
                "use strict";

                $(function () {
                    // Multiple fleet swiper instances
                    $(".fleet-swiper").each(function (index, element) {
                        var $this = $(this);
                        var swiper = new Swiper(this, {
                            slidesPerView: 5,
                            spaceBetween: 0,
                            grabCursor: true,
                            breakpoints: {
                                1600: {
                                    slidesPerView: 4,
                                    spaceBetween: 0
                                },
                                1250: {
                                    slidesPerView: 3,
                                    spaceBetween: 0
                                },
                                996: {
                                    slidesPerView: 2,
                                    spaceBetween: 0
                                },
                                700: {
                                    slidesPerView: 1,
                                    spaceBetween: 0
                                }
                            },
                            nextButton: $this.parent().find(".swiper-button-next")[0],
                            prevButton: $this.parent().find(".swiper-button-prev")[0]
                        });
                    });

                    var adjustFleetSwiperSize = function () {
                        var $swiper = $('.fleet-swiper'),
                            maxHeight = 0;
                        $('article', $swiper).each(function () {
                            if ($(this).height() > maxHeight)
                                maxHeight = $(this).height();
                        })

                        $swiper.css({
                            'min-height': maxHeight + 130,
                        })
                    }

                    $(window).load(function () {
                        equalheight('.fleet-swiper figure');
                        adjustFleetSwiperSize();
                    });


                    $(window).resize(function () {
                        equalheight('.fleet-swiper figure');
                    });

                    setTimeout(adjustFleetSwiperSize, 500);
                });

            },

            dom_show_more_items: function($targetEl) {

                $('.show-more-items-btn', $targetEl).on("click", function (e) {
                    e.preventDefault();
                    var $el = $(this),
                        $parent = $(this).parents('.extras-rows-container:first');
                    $parent.find('.row.hide:eq(0)').hide().removeClass('hide').slideDown(600);
                    if ($parent.find('.row.hide').length == 0) {
                        $el.parent().hide();
                    }
                });

            },

            dom_booking_step_3: function () {
                $('.mobile-overlay').each(function() {
                    var $self = $(this);

                    $(document).on('scroll', function() {
                        if ($(document).scrollTop() >= $self.parent().position().top && $self.data('shown') != '1') {
                            $self.data('shown', '1');
                            setTimeout(function () {
                                $self.fadeOut(200);
                            }, 5000);
                        }
                    });

                    $self.on('mousedown', function() {
                        $self.fadeOut(200);
                    });
                });
            },

            dom_booking_step_4: function () {

                $("#driver_birth_date").each(function () {
                    var $self = $(this);
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "name": $self.data('field-name'),
                        "minAge": 18,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(".select-date-picker").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": 18,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(function () {
                    var slideSpeed = 500;

                    $('.form-sub-container .show-btn').on("click", function (e) {
                        e.preventDefault();
                        var $el = $(this).closest('.form-sub-container');
                        $el.find('.section-body-container').slideDown(slideSpeed);
                        $el.removeClass('body-container-hidden');
                        $el.find('.section-enabled-flag').val('1');
                    });

                    $('.form-sub-container .hide-btn').on("click", function (e) {
                        e.preventDefault();
                        var $el = $(this).closest('.form-sub-container');
                        $el.find('.section-body-container').slideUp(slideSpeed);
                        $el.addClass('body-container-hidden');
                        $el.find('.section-enabled-flag').val('0');
                    });

                    $('#sameCustomerAsDriverNo').on("change", function () {
                        $('#customerMandatoryInfo').slideDown(slideSpeed, function () {
                            $('#customerOptionalInfo').slideDown(slideSpeed / 2);
                        });
                    });

                    $('#sameCustomerAsDriverYes').on("change", function () {
                        $('#customerOptionalInfo').slideUp(slideSpeed / 2, function () {
                            $('#customerMandatoryInfo').slideUp(slideSpeed / 2);
                        });
                    });
                });

                // DatePickers
                $(".date-picker").each(function () {

                    var $el = $(this);

                    // Date format sent to server
                    var dateFormat = $(this).data('date-format') || "Y-m-d";
                    // Date format presented to user
                    var altFormat = $(this).data('alt-format') || "d/m/Y";
                    // Date input mask presented to user
                    var altMask = $(this).data('alt-mask') || "99/99/9999";

                    var yearSpan = 0,
                        defaultYearSpan = 0;
                    if ($(this).data('year-span') != null) {
                        yearSpan = parseInt($(this).data('year-span'));
                    }
                    if ($(this).data('default-year-span') != null) {
                        defaultYearSpan = parseInt($(this).data('default-year-span'));
                    }

                    var minDate = $(this).hasClass('after-today') ? new Date(new Date().setFullYear(new Date().getFullYear() + yearSpan)) : null;
                    var maxDate = $(this).hasClass('before-today') ? new Date(new Date().setFullYear(new Date().getFullYear() - yearSpan)) : null;

                    var defaultDate = defaultYearSpan > 0 ? new Date(new Date().setFullYear(new Date().getFullYear() + yearSpan)) : null;
                    var locale = $('html').attr('lang');

                    var picker = $(this).flatpickr({
                        dateFormat: dateFormat,
                        altInputClass: "form-control",
                        altInput: true,
                        locale: locale,
                        altFormat: altFormat,
                        minDate: minDate,
                        maxDate: maxDate,
                        disableMobile: true,
                        // allowInput: !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
                        parseDate: function (dateStr) {
                            var fmt = new DateFormatter();
                            var date = fmt.parseDate(dateStr, altFormat);
                            if (date == null)
                                return new Date();

                            return date;
                        },
                    });

                    if (yearSpan > 0) {
                        if (minDate != null) {
                            picker.jumpToDate(minDate);
                        } else if (maxDate != null) {
                            picker.jumpToDate(maxDate);
                        }
                    }

                    if(defaultDate != null) {
                        picker.jumpToDate(defaultDate);
                    }

                    // Date mask
                    // $(this).parent().find('.flatpickr-input').each(function () {
                    //     if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                    //         $(this).mask(altMask);
                    //     }
                    //     $(this).on('change', function () {
                    //         $el.val($(this).val());
                    //     });
                    // });
                });
            },

            dom_booking_step_5: function () {
                "use strict";
                $(function(){
                    $('.round-radio-block').on("click", function() {
                        $(this).parents('.section-body-container:first').find('.round-radio-block').removeClass('active');
                        $(this).find('input[type=radio]').prop("checked", true);
                        $(this).addClass('active');
                    });
                });
            },

            dom_booking: function () {
                "use strict";
                // Booking summary top bar
                $(window).scroll(function () {
                    var $elem = $('.booking-summary .price-box').eq(0);
                    if ($(window).scrollTop() > $elem.offset().top) {
                        $('.booking-summary-bar').removeClass('animate-out').addClass('animate-in');
                    } else {
                        $('.booking-summary-bar.animate-in').removeClass('animate-in').addClass('animate-out');
                    }
                });
            },

            dom_stations_maps: function () {

                $(function () {
                    "use strict";

                    var reloadMapProperties = function (mapInstance, stationElem) {
                        mapInstance.removeMarkers();
                        mapInstance.addMarker({
                            lat: parseFloat(stationElem.data('lat')),
                            lng: parseFloat(stationElem.data('lng')),
                            title: 'Ecomobile - ' + stationElem.data('title'),
                        });
                        mapInstance.setCenter(stationElem.data('lat'), stationElem.data('lng'));
                        mapInstance.refresh();
                    }

                    $('.station-info').each(function () {
                        var $stationPopup = $(this),
                            $stationElem = $('.station-info-data', $stationPopup),
                            defaultIcon = $('.pre-icon', $stationPopup).data('default-img');

                        if ($stationElem.length > 0) {

                            $('.contact-us-btn', $stationElem).on('click', function() {
                                if($(this).data('target-url')) {
                                    window.location = $(this).data('target-url');
                                }else{
                                    $('html, body').animate({scrollTop: $('form:first').length > 0 ? $('form:first').parent().offset().top - 100 : 0}, 800, function() {
                                        $('form:first input:first').trigger('focus');
                                    });
                                }
                            });

                            $('.stations-list button').off("click").on("click", function () {
                                // Load data
                                var data = $(this).data('info');
                                $('.st-title', $stationElem).html(data.title).parent().attr('style', !data.title?'display: none':'');
                                $('.st-observations', $stationElem).html(data.observations).parent().attr('style', !data.title?'display: none':'');
                                $('.st-address', $stationElem).html(data.address).parent().attr('style', !data.address?'display: none':'');
                                $('.st-phone-1', $stationElem).html(data.phone_1).parent().attr('style', !data.phone_1?'display: none':'');
                                $('.st-phone-2', $stationElem).html(data.phone_2).parent().attr('style', !data.phone_2?'display: none':'');
                                $('.st-email', $stationElem).html(data.email).parent().attr('style', !data.email?'display: none':'');
                                $('.st-schedule-open', $stationElem).html(data.working_days).parent().attr('style', !data.working_days?'display: none':'');
                                $('.st-schedule-closed-inner', $stationElem).html(data.non_working_days).parent().attr('style', !data.non_working_days?'display: none':'');
                                $('.pre-icon', $stationPopup).html(data.icon ? '<img src="' + data.icon + '" />' : '<img src="' + defaultIcon + '" />');

                                $('img[src$=".svg"]', $stationPopup).each(function () {
                                    var $img = jQuery(this);
                                    var imgURL = $img.attr('src');
                                    var attributes = $img.prop("attributes");

                                    $.get(imgURL, function (data) {
                                        // Get the SVG tag, ignore the rest
                                        var $svg = jQuery(data).find('svg');

                                        // Remove any invalid XML tags
                                        $svg = $svg.removeAttr('xmlns:a');

                                        // Loop through IMG attributes and apply on SVG
                                        $.each(attributes, function () {
                                            $svg.attr(this.name, this.value);
                                        });

                                        // Replace IMG with SVG
                                        $img.replaceWith($svg);
                                    }, 'xml');
                                });

                                if(data.lat != '' && data.lng != '') {
                                    $stationElem.data('lat', data.lat);
                                    $stationElem.data('lng', data.lng);
                                }else{
                                    $stationElem.data('lat', 0);
                                    $stationElem.data('lng', 0);
                                }

                                $stationPopup.removeClass('animate-in animate-out').addClass('animate-in').show();

                                // Update .station-info-data from server and then reload map properties
                                reloadMapProperties(map, $stationElem);

                            });

                            var map = new GMaps({
                                div: '.map',
                                lat: parseFloat($stationElem.data('lat')),
                                lng: parseFloat($stationElem.data('lng')),
                                enableNewStyle: true,
                                zoom: 12
                            });

                            $(this).on('click', '.close-icon', function () {
                                $stationPopup.removeClass('animate-in animate-out').addClass('animate-out');
                                setTimeout(function () {
                                    $stationPopup.hide();
                                }, 1000);
                            });
                        }
                    });
                });
            },

            // SVG Supported Pages
            dom_svg: function () {
                /*
                 * Replace all SVG images with inline SVG (only for .icon classes)
                 */
                $('img[src$=".svg"].icon').each(function () {
                    var $img = jQuery(this);
                    var imgURL = $img.attr('src');
                    var attributes = $img.prop("attributes");

                    $.get(imgURL, function (data) {
                        // Get the SVG tag, ignore the rest
                        var $svg = jQuery(data).find('svg');

                        // Remove any invalid XML tags
                        $svg = $svg.removeAttr('xmlns:a');

                        // Loop through IMG attributes and apply on SVG
                        $.each(attributes, function () {
                            $svg.attr(this.name, this.value);
                        });

                        // Replace IMG with SVG
                        $img.replaceWith($svg);
                    }, 'xml');
                });
            },
            // SVG Supported Pages
            dom_svg_all: function () {
                /*
                 * Replace all SVG images with inline SVG
                 */
                $('img[src$=".svg"]').each(function () {
                    var $img = jQuery(this);
                    var imgURL = $img.attr('src');
                    var attributes = $img.prop("attributes");

                    $.get(imgURL, function (data) {
                        // Get the SVG tag, ignore the rest
                        var $svg = jQuery(data).find('svg');

                        // Remove any invalid XML tags
                        $svg = $svg.removeAttr('xmlns:a');

                        // Loop through IMG attributes and apply on SVG
                        $.each(attributes, function () {
                            $svg.attr(this.name, this.value);
                        });

                        // Replace IMG with SVG
                        $img.replaceWith($svg);
                    }, 'xml');
                });
            },

            dom_popovers: function () {

                $(function () {
                    "use strict";

                    $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                        $(this).popover({
                            placement: 'auto'
                        });
                        $(this).attr('data-event-attached', '');
                    });

                });
            },

            scroll_stripe: function() {
                $.scrolline({
                    frontColor : '#62A60A',
                    backColor: 'transparent'
                });
            },

            // Shared code
            common: function () {
                "use strict";

                function showModalPopup(message, title, subtitle, iconClass) {
                    title = title || '';
                    subtitle = subtitle || '';
                    message = message || '';
                    iconClass = iconClass || '';
                    var $modal = $('#appModal:first');
                    $('.m-title', $modal).html(title);
                    $('.m-subtitle', $modal).html(subtitle);
                    $('.m-message', $modal).html(message);
                    $('#appModalIcon', $modal).removeClass().addClass('icon').addClass(iconClass);
                    $modal.modal('show');
                }

                $(document).on('jedeye.showModalPopup', function (event, message, title, subtitle, iconClass) {
                    showModalPopup(message, title, subtitle, iconClass);
                });

                // code put inside the common property will be executed on all page loads
                function centerModal() {
                    $(this).css('display', 'block');
                    var $dialog = $(this).find(".modal-dialog"),
                        offset = ($(window).height() - $dialog.height()) / 2,
                        bottomMargin = parseInt($dialog.css('marginBottom'), 10);

                    // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height, and keep the margin equal to the bottom margin of the modal
                    if (offset < bottomMargin) offset = bottomMargin;
                    $dialog.css("margin-top", offset);
                }

                $(document).on('show.bs.modal', '.modal', centerModal);
                $(window).on("resize", function () {
                    $('.modal:visible').each(centerModal);
                });

                $(function () {
                    $(".custom-select").each(function () {
                        var $el = $(this);
                        $el.select2({
                            minimumResultsForSearch: -1,
                            placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false
                        })
                    });

                    $('.mobile-main-menu').sliiide({
                        toggle: "#mobileMenuToggle", // the selector for the menu toggle, whatever clickable element you want to activate or deactivate the menu. A click listener will be added to this element.
                        exit_selector: ".mobile-main-menu .close", // the selector for an exit button in the div if needed, when the exit element is clicked the menu will deactivate, suitable for an exit element inside the nav menu or the side bar
                        animation_duration: "0.5s", //how long it takes to slide the menu
                        place: "left", //where is the menu sliding from, possible options are (left | right | top | bottom)
                        animation_curve: "cubic-bezier(0.54, 0.01, 0.57, 1.03)", //animation curve for the sliding animation
                        body_slide: true, //set it to true if you want to use the effect where the entire page slides and not just the div
                        no_scroll: true, //set to true if you want the scrolling disabled while the menu is active,
                        onAnimationStart: function (obj, type) {
                            if (type == 'open') {
                                $("#mobileMenuToggle").animate({
                                    opacity: 0
                                }, 50);
                                $(".mobile-main-menu .close").animate({
                                    opacity: 1
                                }, 200);
                            } else {
                                $("#mobileMenuToggle").animate({
                                    opacity: 1
                                }, 200);
                                $(".mobile-main-menu .close").animate({
                                    opacity: 0
                                }, 200);
                            }
                        }

                    });

                    $('[data-toggle="tooltip"]').tooltip();

                    // Scroll to Top Arrow
                    $(window).scroll(function() {
                        if ($(this).scrollTop() > 500) {
                            if($('#scrollToTop').data('hidden') != '0') {
                                $('#scrollToTop:hidden').data('hidden', '0').stop(true, true).fadeIn();
                            }
                        } else {
                            if($('#scrollToTop').data('hidden') == 0) {
                                $('#scrollToTop').data('hidden', '1').stop(true, true).fadeOut();
                            }
                        }
                    });

                    //Click event to scroll to top
                    $('#scrollToTop').click(function () {
                        $(this).data('hidden', '1').stop(true, true).fadeOut();
                        $('html, body').animate({scrollTop: 0}, 800);
                        return false;
                    });
                });

                // Loading Indicator
                +function ($) {
                    "use strict";
                    delete $.oc;

                    window._isRedirecting = false;

                    $(window).bind('beforeunload', function(){
                        window._isRedirecting = true;
                    });

                    $(document)
                        .off('ajaxPromise', '[data-stripe-load-indicator]');

                    $.oc = {}

                    var StripeLoadIndicator = function () {
                        $('.stripe-loading-indicator').remove(); // Remove original stripLoadIndicator
                    }

                    StripeLoadIndicator.prototype.show = function () {
                        $('.spinner-overlay').show();
                        $(document.body).addClass('loading')
                    }

                    StripeLoadIndicator.prototype.hide = function (force) {
                        if(window._isRedirecting) {
                            return;
                        }
                        $('.spinner-overlay').hide();
                        $(document.body).removeClass('loading')
                    }

                    $(document).ready(function () {
                        $.oc.stripeLoadIndicator = new StripeLoadIndicator()
                    })

                    // STRIPE LOAD INDICATOR DATA-API
                    // ==============

                    $(document)
                        .on('ajaxPromise', '[data-stripe-load-indicator]', function (event) {
                            // Prevent this event from bubbling up to a non-related data-request
                            // element, for example a <form> tag wrapping a <button> tag
                            event.stopPropagation();

                            $.oc.stripeLoadIndicator.show()

                            // This code will cover instances where the element has been removed
                            // from the DOM, making the resolution event below an orphan.
                            var $el = $(this)
                            $(window).one('ajaxUpdateComplete', function () {
                                if ($el.closest('html').length === 0)
                                    $.oc.stripeLoadIndicator.hide()
                            });
                        }).on('ajaxFail ajaxDone', '[data-stripe-load-indicator]', function (event) {
                        event.stopPropagation()
                        $.oc.stripeLoadIndicator.hide()
                    })

                }(window.jQuery);
            }
        }, true);
    }
));
